import { IState } from "../../../redux/reducer";

import { bindActionCreators } from "redux";
import { O2OCommonContainer } from "../../../common/container/O2OContainer";
import { getOrgs } from "../OrgsAction";
import { deleteLinkOrgs, linkOrg, searchLinkOrgs } from './action/LinkOrgsAction';
import { LinkOrgsComponentV2 } from "./LinkOrgsComponentV2";


function mapStateToProps(rootState: IState) {
  return {
    organizations: rootState.organizations,
    commonResponse: rootState.commonResponse,
    linkOrgs: rootState.linkOrgs
  };
}


function mapDispatchToProps(dispatch: any) {
  return {
    getOrgs: bindActionCreators(getOrgs, dispatch),
    linkOrg: bindActionCreators(linkOrg, dispatch),
    searchLinkOrgs: bindActionCreators(searchLinkOrgs, dispatch),
    deleteLinkOrgs: bindActionCreators(deleteLinkOrgs, dispatch)
  };
}

export const LinkOrgsContainer = O2OCommonContainer(LinkOrgsComponentV2, mapStateToProps, mapDispatchToProps)
